import { type PaymentProvider } from '@/types/IPaymentProvider';

export const getPaymentProviderColor = (provider: PaymentProvider): string => {
  switch (provider) {
    case 'yookassa':
      return 'primary';
    case 'cash':
    case 'sber_pay':
    case 'sberbank':
      return 'success';
    case 'mokka':
      return 'danger';
    default:
      return 'warning';
  }
};
